module.exports = __webpack_public_path__ + "static/media/coollogo_com-1324236.53ba4623.png";